import { Injectable } from '@angular/core';
import { Recommendation } from '../models/recommendation.model';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RecommendationService {
  private collectionName = 'recommendation';

  constructor(private afs: AngularFirestore) {}

  getAllRecomendations(): Observable<Recommendation[]> {
    return this.afs.collection<Recommendation>(this.collectionName).valueChanges({ idField: 'id' });
  }

  getRecommendationById(id: string): Observable<Recommendation | undefined> {
    return this.afs.collection<Recommendation>(this.collectionName).doc(id).valueChanges({ idField: 'id' });
  }

  addRecommendation(recommendation: Recommendation) {
    return this.afs.collection<Recommendation>(this.collectionName).add(recommendation);
  }

  updateRecommendation(recId: string, data: Partial<Recommendation>) {
    return this.afs.collection<Recommendation>(this.collectionName).doc(recId).update(data);
  }

  deleteRecommendation(recId: string) {
    return this.afs.collection<Recommendation>(this.collectionName).doc(recId).delete();
  }

  getRecommendationsByGame(gameName: string): Observable<Recommendation[]> {
    return this.afs
      .collection<Recommendation>(this.collectionName, (ref) => ref.where('gameName', '==', gameName))
      .valueChanges({ idField: 'id' });
  }
}
